// React import
import React from 'react';
import {connect} from "react-redux";
// Components imports
import WalletBaseStat from "../WalletBaseStat";
import WalletSearch from "../WalletSearch";
import WalletAddress from "../WalletAddress";
import WalletMenu from "../WalletMenu";
import WalletTokensStats from "../WalletTokensStats";
import WalletAiStats from "../WalletAiStats";
import WalletBalance from "../WalletBalance";
import AiCircle from "../AiCircle";
// Consts imports
import {
    WALLET_TAB_STATS,
    WALLET_TAB_TOKENS,
    WALLET_TAB_BALANCE,
    WALLET_TAB_AI_STATS,
    AI_CHECK_WALLET_WELCOME,
    CHECK_WALLET_WELCOME,
    CHECK_WALLET_PROCESSING,
    CHECK_WALLET_ERROR
} from "../../consts/consts";
// Styles imports
import './CheckWallet.css';
import '../../util.css'

function WalletTab(props) {

    const { page } = props;

    if (page === WALLET_TAB_STATS) {
        return <WalletBaseStat/>
    } else if (page === WALLET_TAB_TOKENS) {
        return <WalletTokensStats/>
    } else if (page === WALLET_TAB_BALANCE) {
        return <WalletBalance/>
    } else if (page === WALLET_TAB_AI_STATS) {
        return <WalletAiStats/>
    } else {
        return null
    }

}

class CheckWallet extends React.Component {

    constructor(props) {
        super(props);
        this.state = {openTab: WALLET_TAB_STATS};
    }

    handleStatsClick = () => {
        this.setState({openTab: WALLET_TAB_STATS});
    }

    handleTokensClick = () => {
        this.setState({openTab: WALLET_TAB_TOKENS});
    }

    handleBalanceClick = () => {
        this.setState({openTab: WALLET_TAB_BALANCE});
    }

    handleAiStatsClick = () => {
        this.setState({openTab: WALLET_TAB_AI_STATS});
    }

    render () {
        const { openTab } = this.state;
        const { status } = this.props.checkWallet;

        if(status === CHECK_WALLET_WELCOME || status === CHECK_WALLET_PROCESSING || status === CHECK_WALLET_ERROR) {
            return(
                <div className={"check-wallet"}>
                    <WalletSearch/>
                    <AiCircle position={AI_CHECK_WALLET_WELCOME}/>
                </div>
            );
        } else {
            return(
                <div className={"check-wallet"}>
                    <WalletSearch/>
                    <WalletAddress/>
                    <WalletMenu tab={openTab}
                                statsClick={this.handleStatsClick} tokensClick={this.handleTokensClick}
                                balanceClick={this.handleBalanceClick} aiStatsClick={this.handleAiStatsClick}/>
                    <WalletTab page={openTab}/>
                </div>
            );
        }

    }

}

const mapStateToProps = ({ checkWallet }) => {
    return { checkWallet };
};

export default connect(mapStateToProps)(CheckWallet);